import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import Apis from '@/Apis/_'
import { DataTablePagination } from '@/types/_'
import { Contrato } from '@/types/core'
import MedicoRecebimentoTipoEnum from '@/types/enum/TipoProducaoEnum'

type Mode = 'CREATE' | 'EDIT'

type SetRegrasDeCalculoModal = {
  name: string,
  value: boolean,
}

type RegrasDeCalculoModal = {
  regraDeCalculo: boolean,
  valoresFixosIncluir: boolean,
  garantiaMinimaIncluir: boolean,
  regraDeCalculoContrato: boolean,
  regraDeCalculoOperadora: boolean,
  setorAtendimento: boolean,
  regraDeCalculoProcedimentosDescartar: boolean,
  procedimentos: boolean,
  procedimentoCompartilhado: boolean,
  plano: boolean,
  filtroProcedimento: boolean,
  regraGarantiaMinimaAddHospital: boolean,
  regraDeCalculoGarantiaMinima: boolean,
  regraDeCalculoIndicacao: boolean,
  procedimentosVinculados: boolean,
  procedimentosVinculadosIncluir: boolean,
  regraDeCalculoGestao: boolean,
  regraDeTeto: boolean,
  regraAgendaGarantiaMinima: boolean,
  equipesProfissional: boolean,
  integrantesEquipeProfissional: boolean,
  regraDeCalculoLocaisExecucao: boolean
}

type KeyDisplay = {
  key: string,
  display: string,
}

interface TabelaPreco {
  id: number,
  identificador: number,
  nome: string,
}

interface Regra {
  id: string,
  descricaoRegra: string | null,
  fatorRegra: number | null,
  valorDeReferencia: KeyDisplay | null,
  valorDeReferenciaTipo: KeyDisplay | string | null,
  valorDeReferenciaFixo: number | null,
  tabelaPrecoPropria: boolean | null,
  tabelaPrecoId: string | null,
  aplicarFatorAcomodacao: boolean | null,
  aplicarFatorFuncaoTabela: boolean | null,
  aplicarPontuacaoProfissional: boolean | null,
  aplicarFatorViaTabela: boolean | null,
  gerarItemInstrumentador: boolean | null,
  filtraPorOperadora: boolean | null,
  filtraPorLocalExecucao: boolean | null,
  filtraPorSetorAtendimento: boolean | null,
  filtraPorCodigoProcedimento: boolean | null,
  ativo: boolean | null,
  considerarTabelaPrecoPontuacao: boolean | null,
  considerarTabelaPediatria: boolean | null,
  descartaPacote: boolean | null,
  descartaPertencePacote: boolean | null,
  createdBy: string | null,
  createdOn: string | null,
  createdByNome: string | null,
  considerarValorPacote: boolean | null,
  filtraPorEquipeProfissional: boolean | null,
  nomeRegra?: string | null,
}

interface Procedimentos {
  valorGarantiaMinima: number,
  codigoProcedimento: string,
  descricaoProcedimento: string,
}

interface RegraDeCalculo {
  aplicarFatorAcomodacao: boolean | null,
  categoriaDedicacao: number,
  cnpjFontePagadora: string | null,
  cnpjPrestador: string | null,
  codigoHisRegra: string | null,
  createdByNome: string | null
  createdOn: string | null,
  descricaoRegra: string | null,
  fatorRegra: number,
  fontePagadoraId: string | null,
  id: string,
  nomeFontePagadora: string | null,
  nomeGrupoHospital: string | null,
  nomeOperadora: string | null,
  nomePrestador: string | null,
  nomeTabelaIndice: string | null,
  nomeTabelaPreco: string | null,
  operadoraId: string | null,
  percentualTaxaAdministrativa: number,
  pontuacaoDedicacao: number,
  prestadorId: string | null,
  removedOn: string | null,
  tabelaIndiceAtual: string | null,
  tabelaIndiceId: string | null,
  tabelaPrecoId: string,
  tabelaPrecoPropria: boolean,
  usarGrupoProcedimentoGeral: boolean | null,
  considerarTabelaPediatria: boolean | null,
  considerarTabelaPrecoProfissional: boolean | null,
  considerarTabelaPrecoPrestador: boolean | null,
  valorDeReferenciaFixo: number,
  valorDeReferencia: {
    key: string,
    display: string,
  },
}

interface RegraDeCalculoContrato {
  id: string,
  contratoId: string,
  fontePagadoraNome: string,
  prestadorNome: string,
  regraCalculoId: string | null
  createdByNome: string | null,
  createdOn: string | null,
  removedBy: string | null,
  removedOn: string | null,
}

interface RegraAgendaGarantiaMinimaContrato {
  id: string,
  nome: string,
  profissionalId: string,
  profissionalNome: string,
  estabelecimentoId: string,
  estabelecimentoNome: string,
  createdOn: string,
  createdBy: string,
  ativo: boolean,
  createdByNome: string,
}

interface RegraAgendaGarantiaMinimaDescarteProcedimentoContrato {
  codigo: string,
  descricao: string,
  createdOn: string,
  createdBy: string,
  createdByNome: string,
}

interface RegraDeCalculoOperadora {
  id: string,
  regraCalculoId: string | null,
  nomeOperadoraHis: string | null,
  codigoHis: string | null,
  createdByNome: string | null,
  createdOn: string | null,
}

export interface PessoaOperadora {
  classificacaoCodigoHis: string | null,
  classificacaoNome: string | null,
  codigoHis: string | null,
  nome: string | null,
  userId: string | null,
}

export interface ClassificacaoOperadora {
  id: number | null,
  classificacaoCodigoHis: string | null,
  classificacaoNome: string | null,
}

interface Prestador {
  documento: string,
  nome: string,
  prestadorId: string,
}

interface Contrato {
  contratoId: string,
  nomeFontePagadora: string | null,
  nomePrestador: string,
  cnpjPrestador: number,
  razaoSocialPrestador: string | null,
}

interface ProcedimentoDescartar {
  id?: string,
  regraCalculoId?: string,
  codigoProcedimento: string,
  descricaoProcedimento: string,
  createdByNome?: string | null,
  createdOn?: string | null,
  removedOn?: string | null,
  removedBy?: string | null,
}

@Module({ namespaced: true, name: 'RegrasDeCalculoStore' })
export default class RegrasDeCalculoStore extends VuexModule {
  public mode: Mode = 'CREATE'
  public modeModalRegraValoresFixos: Mode = 'CREATE'
  public modeIndicacao: Mode = 'CREATE'
  public modeModalRegraGestao: Mode = 'CREATE'
  public modeModalGarantiaMinima: Mode = 'CREATE'
  public localExecucaoSelected: string = ''
  public setorAtendimentoSelected: string = ''
  public modeModalAgendaGarantiaMinima: Mode = 'CREATE'
  public novaRegra: any = {}
  public idDeleteGarantiaMinima: string = ''
  public idRegraAgenda: string = ''
  public descarteProcedimento: any = {}
  public idForDeleteItem: string = ''
  public nomeRegra: string = ''
  public ativo: boolean | null = null
  public filtraPorEquipeProfissional: boolean | null = null

  public modal: RegrasDeCalculoModal = {
    regraDeCalculo: false,
    valoresFixosIncluir: false,
    regraDeCalculoContrato: false,
    regraDeCalculoOperadora: false,
    setorAtendimento: false,
    regraDeCalculoProcedimentosDescartar: false,
    garantiaMinimaIncluir: false,
    procedimentos: false,
    procedimentoCompartilhado: false,
    plano: false,
    filtroProcedimento: false,
    regraGarantiaMinimaAddHospital: false,
    regraDeCalculoGarantiaMinima: false,
    regraDeCalculoIndicacao: false,
    procedimentosVinculados: false,
    procedimentosVinculadosIncluir: false,
    regraDeCalculoGestao: false,
    regraDeTeto: false,
    regraAgendaGarantiaMinima: false,
    equipesProfissional: false,
    integrantesEquipeProfissional: false,
    regraDeCalculoLocaisExecucao: false
  }

  public tiposProducao: { key: MedicoRecebimentoTipoEnum | null; display: string }[] = [
    { key: null, display: 'Todos' },
    { key: MedicoRecebimentoTipoEnum.Material, display: 'Material' },
    { key: MedicoRecebimentoTipoEnum.Procedimento, display: 'Procedimento' },
    { key: MedicoRecebimentoTipoEnum.Exame, display: 'Exame' },
    { key: MedicoRecebimentoTipoEnum.Revisao, display: 'Revisão' },
  ];

  public modalProcedimentoCompartilhadoMode: string = 'CREATE'
  public modalEquipesProfissionalMode: string = 'CREATE'
  public modalVisualizarEquipeMode: string = 'CREATE'

  @Mutation
  setModal(modal: SetRegrasDeCalculoModal) {
    this.modal[modal.name] = modal.value
  }

  @Mutation
  setNovaRegra(value: any) {
    this.novaRegra = value
  }

  @Mutation
  setItemRegraTeto(value: any) {
    this.regraTetoItem = value
  }

  @Mutation
  setIdForDeleteGarantiaMinima(value: any) {
    this.idDeleteGarantiaMinima = value
  }

  @Mutation
  setDescarte(value: any) {
    this.descarteProcedimento = value
  }

  @Mutation
  setIdForDeleteItem(value: any) {
    this.idForDeleteItem = value
  }

  @Mutation
  setMode(mode: Mode) {
    this.mode = mode
  }

  @Mutation
  setModeModalRegraValoresFixos(mode: Mode) {
    this.modeModalRegraValoresFixos = mode
  }

  @Mutation
  setModeIndicacao(value: Mode) {
    this.modeIndicacao = value
  }

  @Mutation
  setModeModalRegraGestao(mode: Mode) {
    this.modeModalRegraGestao = mode
  }

  @Mutation
  setModeModalGarantiaMinima(mode: Mode) {
    this.modeModalGarantiaMinima = mode
  }

  @Mutation
  setModeModalAgendaGarantiaMinima(mode: Mode) {
    this.modeModalAgendaGarantiaMinima = mode
  }

  /** Valores de referência */
  private valoresDeReferenciaDefault: KeyDisplay[] = []
  public valoresDeReferencia: KeyDisplay[] = [...this.valoresDeReferenciaDefault]

  @Mutation
  setValoresDeReferencia(valoresDeReferencia: KeyDisplay[]) {
    this.valoresDeReferencia = valoresDeReferencia
  }

  @Mutation
  clearValoresDeReferencia() {
    this.valoresDeReferencia = [...this.valoresDeReferenciaDefault]
  }

  @Action
  async getValorDeReferenciaEnum() {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getValorDeReferenciaEnum()
      if (request.success) this.context.commit('setValoresDeReferencia', request.data as KeyDisplay[] || [])
      return request
    } catch (error) {
      this.context.commit('clearValoresDeReferencia')
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  /** Regras de calculo */
  private paginacaoRegrasDeCalculoDefault: DataTablePagination = {
    descending: false,
    page: 1,
    rowsPerPage: 25,
    sortBy: null,
    totalItems: 0,
    rowsPerPageItems: [25, 50, 100, 200],
  }

  public paginacaoRegrasDeCalculo: DataTablePagination = { ...this.paginacaoRegrasDeCalculoDefault }
  public paginacaoCadastroHospitaisGarantiaMinimaGlobal: DataTablePagination = { ...this.paginacaoRegrasDeCalculoDefault }
  public paginacaoFiltroPorProcedimento: DataTablePagination = { ...this.paginacaoRegrasDeCalculoDefault }
  public paginacaoRegrasValorFixo: DataTablePagination = { ...this.paginacaoRegrasDeCalculoDefault }
  public paginacaoGarantiaMinima: DataTablePagination = { ...this.paginacaoRegrasDeCalculoDefault }
  public paginacaoRegraGestao: DataTablePagination = { ...this.paginacaoRegrasDeCalculoDefault }
  public paginacaoRegraAgendaGarantiaMinima: DataTablePagination = { ...this.paginacaoRegrasDeCalculoDefault }
  public paginacaoDescarteProcedimentos: DataTablePagination = { ...this.paginacaoRegrasDeCalculoDefault }
  public paginacaoRegraTeto: DataTablePagination = { ...this.paginacaoRegrasDeCalculoDefault }
  public activeTab: number = 0

  get regrasDeCalculoPaginationDefault() {
    return this.paginacaoRegrasDeCalculoDefault
  }

  @Mutation
  setPaginacaoRegrasDeCalculo(val: DataTablePagination) {
    this.paginacaoRegrasDeCalculo = val
  }

  @Mutation
  setPaginacaoCadastroHospitaisGarantiaMinimaGlobal(val: DataTablePagination) {
    this.paginacaoCadastroHospitaisGarantiaMinimaGlobal = val
  }

  @Mutation
  setPaginacaoFiltroPorProcedimento(val: DataTablePagination) {
    this.paginacaoFiltroPorProcedimento = val
  }

  @Mutation
  setPaginacaoEquipesProfissional(val: DataTablePagination) {
    this.paginacaoEquipesProfissional = val
  }

  @Mutation
  setPaginacaoIntegrantesEquipeMedica(val: DataTablePagination) {
    this.paginacaoIntegrantesEquipeMedica = val
  }

  @Mutation
  setActiveTab(tab: number) {
    this.activeTab = tab
  }

  @Mutation
  setIdRegraAgenda(id: string) {
    this.idRegraAgenda = id
  }

  @Mutation
  setPaginacaoRegrasValorFixo(val: DataTablePagination) {
    this.paginacaoRegrasValorFixo = val
  }

  @Mutation
  setPaginacaoGarantiaMinima(val: DataTablePagination) {
    this.paginacaoGarantiaMinima = val
  }

  @Mutation
  setPaginacaoRegraGestao(val: DataTablePagination) {
    this.paginacaoRegraGestao = val
  }

  @Mutation
  setPaginacaoRegraAgendaGarantiaMinima(val: DataTablePagination) {
    this.paginacaoRegraAgendaGarantiaMinima = val
  }

  @Mutation
  setPaginacaoDescarteProcedimentos(val: DataTablePagination) {
    this.paginacaoDescarteProcedimentos = val
  }

  @Mutation
  setPaginacaoRegraTeto(val: DataTablePagination) {
    this.paginacaoRegraTeto = val
  }

  public regrasDeCalculo: any = []
  public regrasValorFixo: any = []
  public regrasGarantiaMinima: any = []
  public regraGestao: any = []
  public regraValorFixoItem: any = {}
  public regraGestaoItem: any = {}
  public regraTetoItem: any = {}
  public regraGarantiaMinimaId: any = ''
  public regraGestorId: any = ''
  public regraTetoId: any = ''
  public regraValorFixoId: any = ''
  public regraGarantiaMinimaItem: any = {}
  public regraAgendaGarantiaMinima: any = []
  public descarteProcedimentos: any[] = []
  public tipoCompartilhamento: any = null
  public grupoRepasse: any = null
  public subGrupoRepasse: any = null
  public regrasTeto: any[] = []
  public loadAddRegraCalculoOperadora: boolean = false

  @Mutation
  setTipoCompartilhamento(value: any) {
    this.tipoCompartilhamento = value
  }

  @Mutation
  setGrupoRepasse(value: any) {
    this.grupoRepasse = value
  }

  @Mutation
  setSubGrupoRepasse(value: any) {
    this.subGrupoRepasse = value
  }

  @Mutation
  setLoadingAddRegraCalculoOperadora(value: boolean) {
    this.loadAddRegraCalculoOperadora = value
  }

  @Mutation
  setRegrasDeCalculo(regrasDeCalculo: RegraDeCalculo[]) {
    this.regrasDeCalculo = regrasDeCalculo
  }

  @Mutation
  setRegrasValorFixo(regrasValorFixo: any[]) {
    this.regrasValorFixo = regrasValorFixo
  }

  @Mutation
  setRegrasGarantiaMinima(regrasGarantiaMinima: any[]) {
    this.regrasGarantiaMinima = regrasGarantiaMinima
  }

  @Mutation
  setIdForDeleteRegraTeto(value: any) {
    this.regraTetoId = value
  }

  @Mutation
  setRegraGestao(regras: any[]) {
    this.regraGestao = regras
  }

  @Mutation
  setRegraValorFixoItem(item: any) {
    this.regraValorFixoItem = item
  }

  @Mutation
  setRegraGarantiaMinimaItem(item: any) {
    this.regraGarantiaMinimaItem = item
  }

  @Mutation
  setRegraGestaoItem(item: any) {
    this.regraGestaoItem = item
  }

  @Mutation
  setRegraTetoItem(item: any) {
    this.regraTetoItem = item
  }

  @Mutation
  clearRegrasDeCalculo() {
    this.regrasDeCalculo = []
  }

  @Mutation
  setRegraDeCalculoIdGarantiaMinima(value: any) {
    this.regraGarantiaMinimaId = value
  }

  @Mutation
  setIdRegraGestor(value: any) {
    this.regraGestorId = value
  }

  @Mutation
  clearRegraGestao() {
    this.regraGestaoItem = {}
  }

  @Mutation
  clearRegraTeto() {
    this.regraTetoItem = {}
  }

  @Mutation
  setRegraValorFixoId(value: any) {
    this.regraValorFixoId = value
  }

  @Mutation
  setRegraAgendaGarantiaMinima(item: RegraAgendaGarantiaMinimaContrato[]) {
    this.regraAgendaGarantiaMinima = item
  }

  @Mutation
  setDescartesProcedimentosAgendaGarantiaMinima(item: any[]) {
    this.descarteProcedimentos = item
  }

  @Mutation
  setRegrasTeto(item: any[]) {
    this.regrasTeto = item
  }

  @Action
  async getRegraCalculoAll(pagination: DataTablePagination) {
    try {
      
      let params: any = {
        pagina: pagination.page || this.paginacaoRegrasDeCalculo.page,
        qtdPorPagina: pagination.rowsPerPage || this.paginacaoRegrasDeCalculo.rowsPerPage,
        ativo: this.ativo,
        filtraPorEquipeProfissional: this.filtraPorEquipeProfissional,
      }

      if (this.nomeRegra) {
        params.nomeRegra = this.nomeRegra
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getRegraCalculoAll(params)
      if (request.success) {
        this.context.commit('setRegrasDeCalculo', request.data.regras as RegraDeCalculo[])
        this.context.commit('setPaginacaoRegrasDeCalculo', {
          descending: false,
          page: pagination.page || this.paginacaoRegrasDeCalculo.page,
          rowsPerPage: pagination.rowsPerPage || this.paginacaoRegrasDeCalculo.rowsPerPage,
          sortBy: null,
          totalItems: request.data.totalRegistros,
          rowsPerPageItems: this.paginacaoRegrasDeCalculo.rowsPerPageItems,
        })
      }
      return request
    } catch (error) {
      this.context.commit('clearRegrasDeCalculo')
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getRegrasValorFixo(pagination: DataTablePagination) {
    try {
      const params: any = {
        fontePagadoraId: this.fontePagadoraField,
        prestadorId: this.prestadorIdSearch,
        profissionalExecutanteId: this.profissionalExecutanteIdSearch,
        pagina: pagination.page || this.paginacaoRegrasValorFixo.page,
        qtdPorPagina: pagination.rowsPerPage || this.paginacaoRegrasValorFixo.rowsPerPage,
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getRegrasValorFixo(params)
      if (request.success) {
        this.context.commit('setRegrasValorFixo', request.data.itens)
        this.context.commit('setPaginacaoRegrasValorFixo', {
          descending: false,
          page: pagination.page || this.paginacaoRegrasValorFixo.page,
          rowsPerPage: pagination.rowsPerPage || this.paginacaoRegrasValorFixo.rowsPerPage,
          sortBy: null,
          totalItems: request.data.totalRegistros,
          rowsPerPageItems: this.paginacaoRegrasValorFixo.rowsPerPageItems,
        })
      }
      return request
    } catch (error) {
      this.context.commit('clearRegrasDeCalculo')
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getRegrasGarantiaMinima(pagination: DataTablePagination) {
    try {
      const params: any = {
        pagina: pagination.page || this.paginacaoRegrasValorFixo.page,
        qtdPorPagina: pagination.rowsPerPage || this.paginacaoRegrasValorFixo.rowsPerPage,
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getRegrasGarantiaMinima(params)
      if (request.success) {
        this.context.commit('setRegrasGarantiaMinima', request.data.itens)
        this.context.commit('setPaginacaoGarantiaMinima', {
          descending: false,
          page: pagination.page || this.paginacaoRegrasValorFixo.page,
          rowsPerPage: pagination.rowsPerPage || this.paginacaoRegrasValorFixo.rowsPerPage,
          sortBy: null,
          totalItems: request.data.totalRegistros,
          rowsPerPageItems: this.paginacaoRegrasValorFixo.rowsPerPageItems,
        })
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getRegraAgendaGarantiaMinima(pagination: DataTablePagination) {
    try {
      const params: any = {
        pagina: pagination.page || this.paginacaoRegraAgendaGarantiaMinima.page,
        qtdPorPagina: pagination.rowsPerPage || this.paginacaoRegraAgendaGarantiaMinima.rowsPerPage,
        nomeRegra: this.nomeRegra,
        profissionalId: this.profissionalIdAgendaGarantiaMinima,
        estabelecimentoId: this.fontePagadoraField,
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getRegrasAgendaGarantiaMinima(params)
      if (request.success) {
        this.context.commit('setRegraAgendaGarantiaMinima', request.data.regras)
        this.context.commit('setPaginacaoRegraAgendaGarantiaMinima', {
          descending: false,
          page: pagination.page || this.paginacaoRegraAgendaGarantiaMinima.page,
          rowsPerPage: pagination.rowsPerPage || this.paginacaoRegraAgendaGarantiaMinima.rowsPerPage,
          sortBy: null,
          totalItems: request.data.totalRegistros,
          rowsPerPageItems: this.paginacaoRegraAgendaGarantiaMinima.rowsPerPageItems,
        })
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async salvarRegra() {
    try {
      const params: any = { ...this.novaRegra }
      Object.entries(params).forEach(([key, value]) => {
        if (['', null, undefined].includes(value as any)) delete params[key]
      })

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.salvarRegra(params)
      if (request.success) {
        this.context.dispatch('getRegraAgendaGarantiaMinima', request.data as string)
        this.context.commit('setIdRegraAgenda', request.data)
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  salvarDescarte() {
    try {
      const params: any = { ...this.descarteProcedimento }
      Object.entries(params).forEach(([key, value]) => {
        if (['', null, undefined].includes(value as any)) delete params[key]
      })
      params.regraAgendaGarantiaMinimaId = this.idRegraAgenda

      const request = Apis.RemuneracaoMedica.RemuneracaoMedicaApi.salvarDescarte(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async deleteDescarte() {
    try {
      const params: any = {
        id: this.idForDeleteItem,
      }
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deleteDescarte(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async deleteRegra() {
    try {
      const params: any = {
        id: this.idDeleteGarantiaMinima,
      }
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deleteRegra(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getRegraTeto(pagination: DataTablePagination) {
    try {
      const params: any = {
        pagina: pagination.page || this.paginacaoRegraTeto.page,
        qtdPorPagina: pagination.rowsPerPage || this.paginacaoRegraTeto.rowsPerPage,
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getRegrasTeto(params)
      if (request.success) {
        this.context.commit('setRegrasTeto', request.data.itens)
        this.context.commit('setPaginacaoRegraTeto', {
          descending: false,
          page: pagination.page || this.paginacaoRegraTeto.page,
          rowsPerPage: pagination.rowsPerPage || this.paginacaoRegraTeto.rowsPerPage,
          sortBy: null,
          totalItems: request.data.totalRegistros,
          rowsPerPageItems: this.paginacaoRegraTeto.rowsPerPageItems,
        })
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async deleteRegraTeto() {
    try {
      const params: any = {
        id: this.regraTetoId,
      }
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deleteRegraTeto(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getDescartesProcedimentosByRegraAgendaGarantiaMinima(payload: { regraId: string, pagination: DataTablePagination }) {
    try {
      const { regraId, pagination } = payload

      const params: any = {
        pagina: pagination.page || this.paginacaoRegraAgendaGarantiaMinima.page,
        qtdPorPagina: pagination.rowsPerPage || this.paginacaoRegraAgendaGarantiaMinima.rowsPerPage,
        regraAgendaGarantiaMinimaId: regraId,
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getDescartesProcedimentosRegrasAgendaGarantiaMinimaById(params)
      if (request.success) {
        this.context.commit('setDescartesProcedimentosAgendaGarantiaMinima', request.data.itens)
        this.context.commit('setPaginacaoDescarteProcedimentos', {
          descending: false,
          page: pagination.page || this.paginacaoRegraAgendaGarantiaMinima.page,
          rowsPerPage: pagination.rowsPerPage || this.paginacaoRegraAgendaGarantiaMinima.rowsPerPage,
          sortBy: null,
          totalItems: request.data.totalRegistros,
          rowsPerPageItems: this.paginacaoRegraAgendaGarantiaMinima.rowsPerPageItems,
        })
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getRegrasGestao(pagination: DataTablePagination) {
    try {
      const params: any = {
        pagina: pagination.page || this.paginacaoRegrasValorFixo.page,
        qtdPorPagina: pagination.rowsPerPage || this.paginacaoRegrasValorFixo.rowsPerPage,
        fontePagadoraId: this.regraGestaoItem.fontePagadoraId,
        localExecucaoId: this.regraGestaoItem.localExecucaoId,
        gestorId: this.regraGestaoItem.gestorId,
        tipoCalculo: this.regraGestaoItem.tipoCalculo,
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getRegrasGestao(params)
      if (request.success) {
        this.context.commit('setRegraGestao', request.data.itens)
        this.context.commit('setPaginacaoRegraGestao', {
          descending: false,
          page: pagination.page || this.paginacaoRegrasValorFixo.page,
          rowsPerPage: pagination.rowsPerPage || this.paginacaoRegrasValorFixo.rowsPerPage,
          sortBy: null,
          totalItems: request.data.totalRegistros,
          rowsPerPageItems: this.paginacaoRegrasValorFixo.rowsPerPageItems,
        })
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  /** Tabela preco */
  private tabelasPrecoDefault: TabelaPreco[] = []
  public tabelasPreco: TabelaPreco[] = [...this.tabelasPrecoDefault]

  @Mutation
  setTabelasPreco(tabelasPreco: TabelaPreco[]) {
    this.tabelasPreco = tabelasPreco
  }

  @Mutation
  clearTabelasPreco() {
    this.tabelasPreco = [...this.tabelasPrecoDefault]
  }

  @Mutation
  clearFilterProdutividade() {
    this.nomeRegra = ''
    this.ativo = null
    this.filtraPorEquipeProfissional = null
  }

  @Action
  async getTabelaPrecoAll() {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getTabelaPrecoAll()
      if (request.success) this.context.commit('setTabelasPreco', request.data as TabelaPreco[] || [])
      return request
    } catch (error) {
      this.context.commit('clearTabelasPreco')
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  /** Regra de calculo */
  private regraDeCalculoDefault: Regra = {
    id: '',
    descricaoRegra: '',
    fatorRegra: null,
    valorDeReferencia: null,
    valorDeReferenciaTipo: null,
    valorDeReferenciaFixo: null,
    tabelaPrecoPropria: null,
    tabelaPrecoId: null,
    aplicarFatorAcomodacao: null,
    aplicarFatorFuncaoTabela: null,
    aplicarPontuacaoProfissional: null,
    aplicarFatorViaTabela: null,
    gerarItemInstrumentador: null,
    filtraPorOperadora: null,
    filtraPorLocalExecucao: null,
    filtraPorSetorAtendimento: null,
    filtraPorCodigoProcedimento: null,
    ativo: true,
    considerarTabelaPrecoPontuacao: null,
    considerarTabelaPediatria: null,
    descartaPacote: null,
    descartaPertencePacote: null,
    createdBy: null,
    createdOn: null,
    createdByNome: null,
    considerarValorPacote: null,
    filtraPorEquipeProfissional: null
  }

  public regraDeCalculo: Regra = { ...this.regraDeCalculoDefault }

  @Mutation
  setRegraDeCalculo(regraDeCalculo: Regra) {
    if (regraDeCalculo.valorDeReferenciaTipo) {
      this.regraDeCalculo = { ...regraDeCalculo, valorDeReferenciaTipo: (regraDeCalculo.valorDeReferenciaTipo as KeyDisplay).key || null }
    } else {
      this.regraDeCalculo = regraDeCalculo
    }
  }

  @Mutation
  setRegraDeCalculoField(keypair: { field: string, value: any}) {
    this.regraDeCalculo[keypair.field] = keypair.value
  }

  @Mutation
  clearRegraDeCalculo() {
    this.regraDeCalculo = { ...this.regraDeCalculoDefault }
  }

  @Mutation
  clearRegraValorFixoItem() {
    this.regraValorFixoItem = {}
  }

  @Mutation
  clearRegraGarantiaMinimaItem() {
    this.regraGarantiaMinimaItem = {}
  }

  @Action
  async getRegraCalculoById(regraCalculoId: string) {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getRegraCalculoById(regraCalculoId)
      if (request.success) this.context.commit('setRegraDeCalculo', request.data as Regra)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async deleteRegraCalculoValorFixo() {
    try {
      const regraCalculoId = this.regraValorFixoId
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deleteRegraCalculoValorFixo(regraCalculoId)
      if (request.success) {
        this.context.dispatch('getRegrasValorFixo', this.paginacaoRegrasValorFixo)
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async deleteRegraGarantiaMinima() {
    try {
      const param: any = {
        id: this.regraGarantiaMinimaId,
      }
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deleteRegraGarantiaMinima(param)
      if (request.success) {
        this.context.dispatch('getRegrasGarantiaMinima', this.paginacaoGarantiaMinima)
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async deleteRegraGestao() {
    try {
      const idCalculoGestor = this.regraGestorId

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deleteRegraGestao(idCalculoGestor)
      if (request.success) {
        this.context.dispatch('getRegrasGestao', this.paginacaoRegrasValorFixo)
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async upsertRegraCalculo() {
    try {
      const params: any = { ...this.regraDeCalculo }

      Object.entries(params).forEach(([key, value]) => {
        if (['', null, undefined].includes(value as any)) delete params[key]
      })

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.upsertRegraCalculo(params)
      if (request.success && !!request.data) {
        this.context.dispatch('getRegraCalculoById', request.data as string)
        this.context.commit('setMode', 'EDIT')
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  /** Contratos */
  public regraDeCalculoContratos: RegraDeCalculoContrato[] = []
  private regraDeCalculoContratoDefault: RegraDeCalculoContrato = {
    id: '',
    contratoId: '',
    fontePagadoraNome: '',
    prestadorNome: '',
    regraCalculoId: '',
    createdByNome: null,
    createdOn: null,
    removedBy: null,
    removedOn: null,
  }

  public regraDeCalculoContrato: RegraDeCalculoContrato = { ...this.regraDeCalculoContratoDefault }
  public prestadoresSearchList: Prestador[] = []
  public prestadorIdSearch: string = ''
  public profissionalExecutanteIdSearch: string = ''

  @Mutation
  setRegraDeCalculoContrato(regraDeCalculoContrato: RegraDeCalculoContrato) {
    this.regraDeCalculoContrato = regraDeCalculoContrato
  }

  @Mutation
  clearRegraDeCalculoContrato() {
    this.regraDeCalculoContrato = { ...this.regraDeCalculoContratoDefault }
  }

  @Mutation
  setRegraDeCalculoContratos(regraDeCalculoContratos: RegraDeCalculoContrato[]) {
    this.regraDeCalculoContratos = regraDeCalculoContratos
  }

  @Mutation
  clearRegraDeCalculoContratos() {
    this.regraDeCalculoContratos = []
  }

  private paginacaoContratosDefault: DataTablePagination = {
    descending: false,
    page: 1,
    rowsPerPage: 25,
    sortBy: null,
    totalItems: 0,
    rowsPerPageItems: [25, 50, 100, 200],
  }

  public paginacaoContratos: DataTablePagination = { ...this.paginacaoContratosDefault }
  get contratoPaginationDefault() {
    return this.paginacaoContratosDefault
  }

  @Mutation
  setPaginacaoContratos(val: DataTablePagination) {
    this.paginacaoContratos = val
  }

  @Mutation
  setPrestadorIdSearch(value: string) {
    this.prestadorIdSearch = value
  }

  @Mutation
  setProfissionalExecutanteIdSearch(value: string) {
    this.profissionalExecutanteIdSearch = value
  }

  @Mutation
  setPrestadoresSearchList(prestadores: Prestador[]) {
    this.prestadoresSearchList = prestadores
  }

  @Mutation
  clearPrestadoresSearchList() {
    this.prestadoresSearchList = [] as Prestador[]
  }

  private paginacaoLocalExecucaoDefault: DataTablePagination = {
    descending: false,
    page: 1,
    rowsPerPage: 25,
    sortBy: null,
    totalItems: 0,
    rowsPerPageItems: [25, 50, 100, 200],
  }

  public paginacaoLocalExecucao: DataTablePagination = { ...this.paginacaoLocalExecucaoDefault }
  get localExecucaoPaginationDefault() {
    return this.paginacaoLocalExecucaoDefault
  }

  @Mutation
  setPaginacaoLocalExecucao(val: DataTablePagination) {
    this.paginacaoLocalExecucao = val
  }

  @Action
  async getRegraCalculoContratoAll(pagination: DataTablePagination) {
    try {
      const params: any = {
        pagina: pagination.page || this.paginacaoContratos.page,
        qtdPorPagina: pagination.rowsPerPage || this.paginacaoContratos.rowsPerPage,
        regraCalculoId: this.regraDeCalculo.id || '',
        prestadorId: this.prestadorIdSearch || '',
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getRegraCalculoContratoAll(params)
      if (request.success) {
        this.context.commit('setRegraDeCalculoContratos', request.data.itens as RegraDeCalculoContrato[] || [])
        this.context.commit('setPaginacaoContratos', {
          descending: false,
          page: pagination.page || this.paginacaoContratos.page,
          rowsPerPage: pagination.rowsPerPage || this.paginacaoContratos.rowsPerPage,
          sortBy: null,
          totalItems: request.data.totalRegistros,
          rowsPerPageItems: this.paginacaoContratos.rowsPerPageItems,
        })
      }
      return request
    } catch (error) {
      this.context.commit('clearRegraDeCalculoContratos')
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getPrestadoresContratoByRegraCalculoId() {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getPrestadoresContratoByRegraCalculoId({
        regraCalculoId: this.regraDeCalculo.id,
        prestadorId: '',
      })

      if (request.success) {
        this.context.commit('setPrestadoresSearchList', request.data as Prestador[])
        this.context.commit('setPrestadorIdSearch', '')
      }

      return request
    } catch (error) {
      this.context.commit('clearPrestadoresSearchList')
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async deleteRegraCalculoContrato(contratoId: string) {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deleteRegraCalculoContrato({ regraCalculoId: this.regraDeCalculo.id, contratoId })
      if (request.success) {
        await this.context.dispatch('getRegraCalculoContratoAll', {
          pagina: this.paginacaoContratos.page,
          qtdPorPagina: this.paginacaoContratos.rowsPerPage,
          regraCalculoId: this.regraDeCalculo.id,
        })
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  /** Lista de prestadores */
  public prestadores: Prestador[] = []
  public profissionais: Prestador[] = []
  public regraCalculoContratoItem: any = {
    prestadorId: '',
    cpfProfissional: '',
    cnpjPrestador: '',
    profissionalId: '',
  }

  @Mutation
  setPrestadores(prestadores: Prestador[]) {
    this.prestadores = prestadores
  }

  @Mutation
  setProfissionais(profissionais: Prestador[]) {
    this.profissionais = profissionais
  }

  @Mutation
  clearPrestadores() {
    this.prestadores = []
  }

  @Mutation
  clearProfissionais() {
    this.profissionais = []
  }

  @Mutation
  setPrestadorId(value: string) {
    this.regraCalculoContratoItem.prestadorId = value
  }

  @Mutation
  setCpfProfissional(value: string) {
    this.regraCalculoContratoItem.cpfProfissional = value
  }

  @Mutation
  setCnpjPrestador(value: string) {
    this.regraCalculoContratoItem.cnpjPrestador = value
  }

  @Action
  async getPrestadorContratoCliente(nome: string = '') {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getPrestadorContratoCliente(nome)
      if (request.success) this.context.commit('setPrestadores', request.data as Prestador[])
      return request
    } catch (error) {
      this.context.commit('clearPrestadores')
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getProfissionalContratoCliente(nome: string = '') {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getProfissionalContratoCliente(nome)
      if (request.success) this.context.commit('setProfissionais', request.data as Prestador[])
      return request
    } catch (error) {
      this.context.commit('clearProfissionais')
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  /** Lista de contratos */
  public contratos: Contrato[] = []

  @Mutation
  setContratos(contratos: Contrato[]) {
    this.contratos = contratos
  }

  @Mutation
  clearContratos() {
    this.contratos = []
  }

  @Action
  async getContratoByPrestador() {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getContratoByPrestador(this.regraCalculoContratoItem)
      if (request.success) this.context.commit('setContratos', request.data as Contrato[] || [])
      return request
    } catch (error) {
      this.context.commit('clearContratos')
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  public contratosId: any[] = []

  @Mutation
  setContratosId(value: any[]) {
    this.contratosId = value
  }

  @Mutation
  clearContratosId() {
    this.contratosId = []
  }

  @Action
  async postRegraCalculoContrato() {
    try {
      const params: any = {
        regraDeCalculoId: this.regraDeCalculo.id,
        contratosId: this.contratosId.map(x => x.contratoId),
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.postRegraCalculoContrato(params)
      if (request.success) {
        await this.context.dispatch('getRegraCalculoContratoAll', {
          pagina: this.paginacaoContratos.page,
          qtdPorPagina: this.paginacaoContratos.rowsPerPage,
          regraCalculoId: this.regraDeCalculo.id,
        })
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  /** Operadoras */
  public regraDeCalculoOperadoras: RegraDeCalculoOperadora[] = []

  @Mutation
  setRegraDeCalculoOperadoras(regraDeCalculoOperadoras: RegraDeCalculoOperadora[]) {
    this.regraDeCalculoOperadoras = regraDeCalculoOperadoras
  }

  @Mutation
  clearRegraDeCalculoOperadoras() {
    this.regraDeCalculoOperadoras = []
  }

  private paginacaoOperadorasDefault: DataTablePagination = {
    descending: false,
    page: 1,
    rowsPerPage: 5,
    sortBy: null,
    totalItems: 0,
    rowsPerPageItems: [5, 10, 20, 25],
  }

  public paginacaoOperadoras: DataTablePagination = { ...this.paginacaoOperadorasDefault }
  public paginacaoSetorAtendimento: DataTablePagination = { ...this.paginacaoOperadorasDefault }
  public regraDeCalculoId: any = ''
  public locaisExecucaoList: any[] = []
  public setorAtendimentoList: any[] = []
  public localExecucaoRegraCalculo: any[] = []
  public setorAtendimentoTable: any[] = []

  get operadoraPaginationDefault() {
    return this.paginacaoOperadorasDefault
  }

  @Mutation
  setLocalExecucaoRegraCalculo(value: any[]) {
    this.localExecucaoRegraCalculo = value
  }

  @Mutation
  setSetorAtendimentoTable(value: any[]) {
    this.setorAtendimentoTable = value
  }

  @Mutation
  setPaginacaoOperadoras(val: DataTablePagination) {
    this.paginacaoOperadoras = val
  }

  @Mutation
  setLocaisExecucaoList(value: any[]) {
    this.locaisExecucaoList = value
  }

  @Mutation
  setSetorAtendimentoList(value: any[]) {
    this.setorAtendimentoList = value
  }

  @Mutation
  setRegraDeCalculoId(value: any) {
    this.regraDeCalculoId = value
  }

  @Action
  async getLocalExecucaoByRegraCalculoId(pagination: DataTablePagination) {
    try {
      const params: any = {
        pagina: pagination.page || this.paginacaoLocalExecucao.page,
        qtdPorPagina: pagination.rowsPerPage || this.paginacaoLocalExecucao.rowsPerPage,
        regraCalculoId: this.regraDeCalculoId,
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getLocalExecucaoByRegraCalculoId(params)
      if (request.success) {
        this.context.commit('setLocalExecucaoRegraCalculo', request.data.itens)
        this.context.commit('setPaginacaoLocalExecucao', {
          descending: false,
          page: pagination.page || this.paginacaoLocalExecucao.page,
          rowsPerPage: pagination.rowsPerPage || this.paginacaoLocalExecucao.rowsPerPage,
          sortBy: null,
          totalItems: request.data.totalRegistros,
          rowsPerPageItems: this.paginacaoLocalExecucao.rowsPerPageItems,
        })
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getSetorAtendimentoByRegraCalculoId() {
    try {
      const params: any = {
        regraCalculoId: this.regraDeCalculoId,
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getSetorAtendimentoByRegraCalculoId(params)
      if (request.success) {
        this.context.commit('setSetorAtendimentoTable', request.data.itens)
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getRegraCalculoOperadoraAll(pagination: DataTablePagination) {
    try {
      const params: any = {
        pagina: pagination.page || this.paginacaoOperadoras.page,
        qtdPorPagina: pagination.rowsPerPage || this.paginacaoOperadoras.rowsPerPage,
        regraCalculoId: this.regraDeCalculo.id || '',
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getRegraCalculoOperadoraAll(params)
      if (request.success) {
        this.context.commit('setRegraDeCalculoOperadoras', request.data.itens as RegraDeCalculoOperadora[] || [])
        this.context.commit('setPaginacaoOperadoras', {
          descending: false,
          page: pagination.page || this.paginacaoOperadoras.page,
          rowsPerPage: pagination.rowsPerPage || this.paginacaoOperadoras.rowsPerPage,
          sortBy: null,
          totalItems: request.data.totalRegistros,
          rowsPerPageItems: this.paginacaoOperadoras.rowsPerPageItems,
        })
      }
      return request
    } catch (error) {
      this.context.commit('clearRegraDeCalculoOperadoras')
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  /** Pessoa Operadora */
  public pessoaOperadoras: PessoaOperadora[] = []

  @Mutation
  setPessoaOperadoras(operadoras: PessoaOperadora[]) {
    this.pessoaOperadoras = operadoras
  }

  @Mutation
  clearPessoaOperadoras() {
    this.pessoaOperadoras = []
  }

  @Action
  async getPessoaOperadoraAll() {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getPessoaOperadoraAll()
      if (request.success) this.context.commit('setPessoaOperadoras', request.data.convenios as PessoaOperadora[] || [])
      return request
    } catch (error) {
      this.context.commit('clearPessoaOperadoras')
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  /** Classificacao Operadora */
  public classificacaoOperadoras: ClassificacaoOperadora[] = []

  @Mutation
  setClassificacaoOperadoras(classificacaoOperadoras: ClassificacaoOperadora[]) {
    this.classificacaoOperadoras = classificacaoOperadoras
  }

  @Mutation
  clearClassificacaoOperadoras() {
    this.classificacaoOperadoras = []
  }

  @Action
  async getClassificacaoOperadoraAll() {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getClassificacaoOperadoraAll()
      if (request.success) this.context.commit('setClassificacaoOperadoras', request.data as ClassificacaoOperadora[] || [])
      return request
    } catch (error) {
      this.context.commit('clearClassificacaoOperadoras')
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  public porOperadoraOuPorClassificacao: 'PorOperadora' | 'PorClassificacao' = 'PorOperadora'

  @Mutation
  setPorOperadoraOuPorClassificacao(value: 'PorOperadora' | 'PorClassificacao') {
    this.porOperadoraOuPorClassificacao = value
  }

  /** Incluir Operadora */
  private pessoaOperadoraAIncluirDefault: PessoaOperadora = {
    userId: null,
    nome: null,
    classificacaoCodigoHis: null,
    classificacaoNome: null,
    codigoHis: null,
  }

  public pessoaOperadoraAIncluir: PessoaOperadora = { ...this.pessoaOperadoraAIncluirDefault }

  @Mutation
  setPessoaOperadoraAIncluir(val: PessoaOperadora) {
    this.pessoaOperadoraAIncluir = val
  }

  @Mutation
  setLocalExecucaoSelected(value: any) {
    this.localExecucaoSelected = value
  }

  @Mutation
  setSetorAtendimentoSelected(value: any) {
    this.setorAtendimentoSelected = value
  }

  @Mutation
  clearPessoaOperadoraAIncluir() {
    this.pessoaOperadoraAIncluir = { ...this.pessoaOperadoraAIncluirDefault }
  }

  private classificacaoOperadoraAIncluirDefault: ClassificacaoOperadora = {
    id: null,
    classificacaoCodigoHis: null,
    classificacaoNome: null,
  }

  public classificacaoOperadoraAIncluir: ClassificacaoOperadora = { ...this.classificacaoOperadoraAIncluirDefault }

  @Mutation
  setClassificacaoOperadoraAIncluir(val: ClassificacaoOperadora) {
    this.classificacaoOperadoraAIncluir = val
  }

  @Mutation
  clearClassificacaoOperadoraAIncluir() {
    this.classificacaoOperadoraAIncluir = { ...this.classificacaoOperadoraAIncluirDefault }
  }

  @Mutation
  setPaginacaoSetorAtendimento(val: DataTablePagination) {
    this.paginacaoSetorAtendimento = val
  }

  @Action
  async addRegraCalculoOperadora() {
    try {
      const params: any = this.porOperadoraOuPorClassificacao === 'PorOperadora'
        ? { operadoraId: this.pessoaOperadoraAIncluir.userId, regraCalculoId: this.regraDeCalculo.id, hisId: this.pessoaOperadoraAIncluir.codigoHis }
        : { operadoraClassificacaoHospitalId: this.classificacaoOperadoraAIncluir.id, classificacaoCodigoHis: this.classificacaoOperadoraAIncluir.classificacaoCodigoHis, regraCalculoId: this.regraDeCalculo.id }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.addRegraCalculoOperadora(params)
      if (request.success) {
        await this.context.dispatch('getRegraCalculoOperadoraAll', {
          pagina: this.paginacaoOperadoras.page,
          qtdPorPagina: this.paginacaoOperadoras.rowsPerPage,
          regraCalculoId: this.regraDeCalculo.id,
        })
      }
      // if (request.data === undefined) return { success: false, message: 'Ocorreu um erro na requisição.' }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async addRegraLocalExecucao() {
    try {
      const params: any = {
        regraCalculoId: this.regraDeCalculoId,
        localExecucaoId: this.localExecucaoSelected,
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.addRegraLocalExecucao(params)
      if (request.success) {
        await this.context.dispatch('getLocalExecucaoByRegraCalculoId', {
          pagina: this.paginacaoLocalExecucao.page,
          qtdPorPagina: this.paginacaoLocalExecucao.rowsPerPage,
          regraCalculoId: this.regraDeCalculoId,
        })
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async addRegraSetorAtendimento() {
    try {
      const params: any = {
        regraCalculoId: this.regraDeCalculoId,
        setorAtendimentoId: this.setorAtendimentoSelected,
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.addRegraSetorAtendimento(params)
      if (request.success) {
        await this.context.dispatch('getSetorAtendimentoByRegraCalculoId')
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async removeRegraCalculoOperadora(regraCalculoOperadoraId: string) {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.removeRegraCalculoOperadora(regraCalculoOperadoraId)
      if (request.success) {
        await this.context.dispatch('getRegraCalculoOperadoraAll', {
          pagina: this.paginacaoOperadoras.page,
          qtdPorPagina: this.paginacaoOperadoras.rowsPerPage,
          regraCalculoId: this.regraDeCalculo.id,
        })
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async removeLocalExecucao(regraId: string) {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.removeLocalExecucao(regraId)
      if (request.success) {
        await this.context.dispatch('getLocalExecucaoByRegraCalculoId', {
          pagina: this.paginacaoLocalExecucao.page,
          qtdPorPagina: this.paginacaoLocalExecucao.rowsPerPage,
          regraCalculoId: this.regraDeCalculoId,
        })
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async removeSetorAtendimento(regraId: string) {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.removeSetorAtendimento(regraId)
      if (request.success) {
        await this.context.dispatch('getSetorAtendimentoByRegraCalculoId')
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getSetorAtendimentoList(payload: { page: number, pageSize: number, term?: string }) {
    try {
      const page = payload.page
      const pageSize = payload.pageSize
      const descricao = payload.term ? String(payload.term).trim() : ''

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getSetorAtendimentoList({
        pagina: page,
        qtdPorPagina: pageSize,
        descricao: descricao || undefined
      })

      if (request.success) {
        const d = request.data || {}

        this.context.commit('setSetorAtendimentoList', d.itens || [])

        this.context.commit('setPaginacaoSetorAtendimento', {
          descending: false,
          page: d.paginaAtual || page,
          rowsPerPage: d.qtdPorPagina || pageSize,
          sortBy: null,
          totalItems: d.totalRegistros || 0,
          rowsPerPageItems: this.paginacaoSetorAtendimento.rowsPerPageItems
        })
      }

      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao buscar os setores de atendimento.' }
    }
  }

  /** Procedimentos descartar */
  public regraDeCalculoProcedimentosDescartar: ProcedimentoDescartar[] = []

  @Mutation
  setRegraDeCalculoProcedimentosDescartar(regraDeCalculoProcedimentosDescartar: ProcedimentoDescartar[]) {
    this.regraDeCalculoProcedimentosDescartar = regraDeCalculoProcedimentosDescartar
  }

  @Mutation
  clearRegraDeCalculoProcedimentosDescartar() {
    this.regraDeCalculoProcedimentosDescartar = []
  }

  private paginacaoProcedimentosDescartarDefault: DataTablePagination = {
    descending: false,
    page: 1,
    rowsPerPage: 5,
    sortBy: null,
    totalItems: 0,
    rowsPerPageItems: [5, 10, 20, 25],
  }

  public paginacaoProcedimentosDescartar: DataTablePagination = { ...this.paginacaoProcedimentosDescartarDefault }
  get procedimentosDescartarPaginationDefault() {
    return this.paginacaoProcedimentosDescartarDefault
  }

  @Mutation
  setPaginacaoProcedimentosDescartar(val: DataTablePagination) {
    this.paginacaoProcedimentosDescartar = val
  }

  @Action
  async getRegraCalculoProcedimentoDescartarAll(pagination: DataTablePagination) {
    try {
      const params: any = {
        pagina: pagination.page || this.paginacaoProcedimentosDescartar.page,
        qtdPorPagina: pagination.rowsPerPage || this.paginacaoProcedimentosDescartar.rowsPerPage,
        regraCalculoId: this.regraDeCalculo.id || '',
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getRegraCalculoProcedimentoDescartarAll(params)
      if (request.success) {
        this.context.commit('setRegraDeCalculoProcedimentosDescartar', request.data.itens as ProcedimentoDescartar[] || [])
        this.context.commit('setPaginacaoProcedimentosDescartar', {
          descending: false,
          page: pagination.page || this.paginacaoProcedimentosDescartar.page,
          rowsPerPage: pagination.rowsPerPage || this.paginacaoProcedimentosDescartar.rowsPerPage,
          sortBy: null,
          totalItems: request.data.totalRegistros,
          rowsPerPageItems: this.paginacaoProcedimentosDescartar.rowsPerPageItems,
        })
      }
      return request
    } catch (error) {
      this.context.commit('clearRegraDeCalculoProcedimentosDescartar')
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async removeRegraCalculoProcedimentoDescartar(procedimentoDescartarId: string) {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.removeRegraCalculoProcedimentoDescartar({
        regraCalculoId: this.regraDeCalculo.id,
        procedimentoDescartarId,
      })

      if (request.success) {
        await this.context.dispatch('getRegraCalculoProcedimentoDescartarAll', {
          pagina: this.paginacaoProcedimentosDescartar.page,
          qtdPorPagina: this.paginacaoProcedimentosDescartar.rowsPerPage,
          regraCalculoId: this.regraDeCalculo.id,
        })
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  procedimentoDescartarDefault: ProcedimentoDescartar = {
    codigoProcedimento: '',
    descricaoProcedimento: '',
  }

  procedimentoDescartar: ProcedimentoDescartar = { ...this.procedimentoDescartarDefault }

  @Mutation
  setProcedimentoDescartar(val: ProcedimentoDescartar) {
    this.procedimentoDescartar = val
  }

  @Mutation
  clearProcedimentoDescartar() {
    this.procedimentoDescartar = { ...this.procedimentoDescartarDefault }
  }

  @Action
  async postRegraCalculoProcedimentoDescartar() {
    try {
      const params: any = {
        regraCalculoId: this.regraDeCalculo.id,
        ...this.procedimentoDescartar,
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.postRegraCalculoProcedimentoDescartar(params)
      if (request.success) {
        await this.context.dispatch('getRegraCalculoProcedimentoDescartarAll', {
          pagina: this.paginacaoProcedimentosDescartar.page,
          qtdPorPagina: this.paginacaoProcedimentosDescartar.rowsPerPage,
          regraCalculoId: this.regraDeCalculo.id,
        })
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  /** Procedimentos */
  private paginacaoDefault: DataTablePagination = {
    descending: false,
    page: 1,
    rowsPerPage: 5,
    sortBy: null,
    totalItems: 0,
    rowsPerPageItems: [5, 10, 20, 25],
  }

  private procedimentosDefault: any = []
  public procedimentos: any = [...this.procedimentosDefault]
  public filtroPorProcedimentoList: any[] = []
  public procedimentoCompartilhado: any = []
  public procedimentoCompartilhadoId: string = ''
  public idForDeleteProcedimentoVinculado: string = ''
  public funcoesProcedimento: any = []
  public fontesPagadoras: any = []
  public hospitalGarantiaMinimaGlobal: string = ''
  public gruposRepasse: any = []
  public subGruposRepasse: any = []
  public gestores: any = []
  public locaisExecucao: any = []
  public prestadoresRepasse: any = []
  public prestadoresFiltroValorFixo: any = []
  public transacaoFinanceiraList: any = []
  public profissionaisExecutantes: any = []
  public profissionaisExecutantesIndicados: any = []
  public profissionaisExecutantesAtribuidos: any = []
  public profissionaisExecutantesFiltroValorFixo: any = []
   public profissionaisExecutantesModal: any[] = []
  
  public centroDeCusto: any = []
  public tiposItemDesconsiderado: any = []
  public centroDeCustoId: string = ''
  public localExecucaoById: any = []
  
  public transacaoFinanceira: any = []
  public fontePagadoraField: any = null
  public profissionalIdAgendaGarantiaMinima: string | null = null
  public tipoField: any = null
  public valorReferencia: any = 'ValorCalculado'
  public valoresReferencia: any = null
  public funcaoProcOrigem: string = ''
  public funcaoProcDestino: string = ''
  public planos: any = []
  public planosAbrangencia: any = []
  public idForDeleteHospital: any = ''
  public hospitaisGarantiaMinimaGlobal: any = []
  public valorReferenciaTipos: KeyDisplay[] = []
  public valorReferenciaTeto: KeyDisplay[] = []
  public tipoProducao: KeyDisplay[] = []
  public tipos: KeyDisplay[] = []
  public valorGarantiaMinima: number = 0
  public procedimentosVinculados: any = []
  public criarItemGrupoRepasseDiferente: boolean = false
  public percentualAplicar: number = 0
  public codigoTuss: string = ''
  public agendaGarantiaMinimaId: string = ''
  public codigoProcedimento: string = ''
  public selectedAbrangencia: string = ''
  public fatorPlano: string = ''
  public descricaoProcedimento: string = ''
  public codigoFiltroProcedimento: string = ''
  public descricaoFiltroProcedimento: string = ''
  public equipesProfissional: any = []
  public resumoEquipeMedica: any[] = []
  public selectedEquipeMedica: number = 0
  public selectedEquipeMedicaEdit: number = 0
  public profissionaisEquipeMedica: any[] = []

  public paginacaoProcedimentos: DataTablePagination = { ...this.paginacaoDefault }
  public paginacaoPlanos: DataTablePagination = { ...this.paginacaoDefault }
  public paginacaoEquipesProfissional: DataTablePagination = { ...this.paginacaoDefault }
  public paginacaoIntegrantesEquipeMedica: DataTablePagination = { ...this.paginacaoDefault }

  @Mutation
  setPaginacaoProcedimentos(val: DataTablePagination) {
    this.paginacaoProcedimentos = val
  }

  @Mutation
  setSelectedAbrangencia(value: any) {
    this.selectedAbrangencia = value
  }

  @Mutation
  setFatorPlano(value: any) {
    this.fatorPlano = value
  }

  @Mutation
  setPaginacaoPlanos(val: DataTablePagination) {
    this.paginacaoPlanos = val
  }

  @Mutation
  setPlanosAbrangencia(value: any[]) {
    this.planosAbrangencia = value
  }

  @Mutation
  setHospitaisGarantiaMinimaGlobal(value: any[]) {
    this.hospitaisGarantiaMinimaGlobal = value
  }

  @Mutation
  setIdForDeleteHospital(value: any) {
    this.idForDeleteHospital = value
  }

  @Mutation
  setValorReferenciaTipos(value: KeyDisplay[]) {
    this.valorReferenciaTipos = value
  }

  @Mutation
  setTipos(value: KeyDisplay[]) {
    this.tipos = value
  }

  @Mutation
  setProcedimentos(procedimentos: Procedimentos[]) {
    this.procedimentos = procedimentos
  }

  @Mutation
  setFiltroPorProcedimentoList(procedimentos: any[]) {
    this.filtroPorProcedimentoList = procedimentos
  }

  @Mutation
  setCodigoFiltroProcedimento(value: string) {
    this.codigoFiltroProcedimento = value
  }

  @Mutation
  setDescricaoFiltroProcedimento(value: string) {
    this.descricaoFiltroProcedimento = value
  }

  @Mutation
  setProcedimentoCompartilhado(procedimento: any) {
    this.procedimentoCompartilhado = procedimento
  }

  @Mutation
  setPercentualAplicar(value: number) {
    this.percentualAplicar = value
  }

  @Mutation
  setCodigoTuss(value: string) {
    this.codigoTuss = value
  }

  @Mutation
  setAgendaGarantiaMinimaId(value: string) {
    this.agendaGarantiaMinimaId = value
  }

  @Mutation
  setValorReferenciaTeto(value: KeyDisplay[]) {
    this.valorReferenciaTeto = value
  }

  @Mutation
  setTipoProducao(value: KeyDisplay[]) {
    this.tipoProducao = value
  }

  @Mutation
  setPlanos(procedimentos: any) {
    this.planos = procedimentos
  }

  @Mutation
  setCriarItemGrupoRepasseDiferente(value: boolean) {
    this.criarItemGrupoRepasseDiferente = value
  }

  @Mutation
  setValorGarantiaMinima(value: number) {
    this.valorGarantiaMinima = value
  }

  @Mutation
  setProcedimentosVinculados(value: any[]) {
    this.procedimentosVinculados = value
  }

  @Mutation
  setCodigoProcedimento(value: string) {
    this.codigoProcedimento = value
  }

  @Mutation
  setDescricaoProcedimento(value: string) {
    this.descricaoProcedimento = value
  }

  @Mutation
  setFuncoesProcedimento(value: any[]) {
    this.funcoesProcedimento = value
  }

  @Mutation
  setFontesPagadoras(value: any[]) {
    this.fontesPagadoras = value
  }

  @Mutation
  setHospitalGarantiaMinimaGlobal(value: string) {
    this.hospitalGarantiaMinimaGlobal = value
  }

  @Mutation
  setGruposRepasse(value: any[]) {
    this.gruposRepasse = value
  }

  @Mutation
  setGestores(value: any[]) {
    this.gestores = value
  }

  @Mutation
  setLocaisExecucao(value: any[]) {
    this.locaisExecucao = value
  }

  @Mutation
  setSubGruposRepasse(value: any[]) {
    this.subGruposRepasse = value
  }

  @Mutation
  setFontePagadoraField(value: any) {
    this.fontePagadoraField = value
  }

  @Mutation
  setProfissionalIdAgendaGarantiaMinima(value: string | null) {
    this.profissionalIdAgendaGarantiaMinima = value
  }

  @Mutation
  setTipoField(value: any) {
    this.tipoField = value
  }

  @Mutation
  setValoresReferencia(value: any) {
    this.valoresReferencia = value
  }

  @Mutation
  setValorReferencia(value: any) {
    this.valorReferencia = value
  }

  @Mutation
  setFuncaoProcOrigem(value: string) {
    this.funcaoProcOrigem = value
  }

  @Mutation
  setFuncaoProcDestino(value: string) {
    this.funcaoProcDestino = value
  }

  @Mutation
  clearProcedimentos() {
    this.procedimentos = [...this.procedimentosDefault]
  }

  @Mutation
  clearProcedimentoCompartilhado() {
    this.procedimentoCompartilhado = []
  }

  @Mutation
  setProcedimentoCompartilhadoId(value: string) {
    this.procedimentoCompartilhadoId = value
  }

  @Mutation
  setIdForDeleteProcedimentoVinculado(value: string) {
    this.idForDeleteProcedimentoVinculado = value
  }

  @Mutation
  setModalProcedimentoCompartilhadoMode(value: string) {
    this.modalProcedimentoCompartilhadoMode = value
  }

  @Mutation
  setPrestadoresRepasse(value: any[]) {
    this.prestadoresRepasse = value
  }

  @Mutation
  setPrestadoresFiltroValorFixo(value: any[]) {
    this.prestadoresFiltroValorFixo = value
  }

  @Mutation
  setTransacaoFinanceira(value: any[]) {
    this.transacaoFinanceiraList = value
  }

  @Mutation
  setProfissionaisExecutantes(value: any[]) {
    this.profissionaisExecutantes = value
  }

  @Mutation
  setProfissionaisExecutantesIndicados(value: any[]) {
    this.profissionaisExecutantesIndicados = value
  }

  @Mutation
  setProfissionaisExecutantesAtribuidos(value: any[]) {
    this.profissionaisExecutantesAtribuidos = value
  }

  @Mutation
  setProfissionaisExecutantesFiltroValorFixo(value: any[]) {
    this.profissionaisExecutantesFiltroValorFixo = value
  }

  @Mutation
  setProfissionaisExecutantesModal(value: any[]) {
    this.profissionaisExecutantesModal = value
  }

  @Mutation
  setCentroDeCusto(value: any[]) {
    this.centroDeCusto = value
  }

  @Mutation
  setTiposItemDesconsiderado(value: any[]) {
    this.tiposItemDesconsiderado = value
  }

  @Mutation
  clearCentroDeCusto() {
    this.centroDeCusto = []
  }

  @Mutation
  setTransacaoFinanceiraFixo(value: any[]) {
    this.transacaoFinanceira = value
  }

  @Mutation
  setLocalExecucaoById(value: any[]) {
    this.localExecucaoById = value
  }

  @Mutation
  clearPlanos() {
    this.planos = []
  }

  @Mutation
  setNomeRegra(value: string) {
    this.nomeRegra = value
  }

  @Mutation
  setAtivo(value: boolean | null) {
    this.ativo = value
  }

  @Mutation
  setFiltrarPorEquipeProfissional(value: boolean | null) {
    this.filtraPorEquipeProfissional = value
  }

  @Mutation
  setModalEquipesProfissionalMode(value: string) {
    this.modalEquipesProfissionalMode = value
  }

  @Action
  async getProcedimentosAll(pagination: DataTablePagination) {
    try {
      const params: any = {
        pagina: pagination.page || this.paginacaoOperadoras.page,
        qtdPorPagina: pagination.rowsPerPage || this.paginacaoOperadoras.rowsPerPage,
        procedimentoId: this.regraDeCalculo.id || '',
      }
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getProcedimentosAll(params)
      if (request.success) {
        this.context.commit('setProcedimentos', request.data.itens as Procedimentos[] || [])
        this.context.commit('setPaginacaoOperadoras', {
          descending: false,
          page: pagination.page || this.paginacaoOperadoras.page,
          rowsPerPage: pagination.rowsPerPage || this.paginacaoOperadoras.rowsPerPage,
          sortBy: null,
          totalItems: request.data.totalRegistros,
          rowsPerPageItems: this.paginacaoOperadoras.rowsPerPageItems,
        })
      }
      return request
    } catch (error) {
      this.context.commit('clearProcedimentos')
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getProcedimentoCompartilhadoAll(pagination: DataTablePagination) {
    try {
      const params: any = {
        pagina: pagination.page || this.paginacaoOperadoras.page,
        qtdPorPagina: pagination.rowsPerPage || this.paginacaoOperadoras.rowsPerPage,
        regraCalculoId: this.regraDeCalculo.id || '',
      }
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getProcedimentoCompartilhadoAll(params)
      if (request.success) {
        this.context.commit('setProcedimentoCompartilhado', request.data.itens || [])
        this.context.commit('setPaginacaoOperadoras', {
          descending: false,
          page: pagination.page || this.paginacaoOperadoras.page,
          rowsPerPage: pagination.rowsPerPage || this.paginacaoOperadoras.rowsPerPage,
          sortBy: null,
          totalItems: request.data.totalRegistros,
          rowsPerPageItems: this.paginacaoOperadoras.rowsPerPageItems,
        })
      }
      return request
    } catch (error) {
      this.context.commit('clearProcedimentoCompartilhado')
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getPlanoAll(pagination: DataTablePagination) {
    try {
      const params: any = {
        pagina: pagination.page || this.paginacaoPlanos.page,
        qtdPorPagina: pagination.rowsPerPage || this.paginacaoPlanos.rowsPerPage,
        regraCalculoId: this.regraDeCalculo.id || '',
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getPlanoAll(params)
      if (request.success) {
        this.context.commit('setPlanos', request.data.itens)
        this.context.commit('setPaginacaoPlanos', {
          descending: false,
          page: pagination.page || this.paginacaoPlanos.page,
          rowsPerPage: pagination.rowsPerPage || this.paginacaoPlanos.rowsPerPage,
          sortBy: null,
          totalItems: request.data.totalRegistros,
          rowsPerPageItems: this.paginacaoPlanos.rowsPerPageItems,
        })
      }
      return request
    } catch (error) {
      this.context.commit('clearPlanos')
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getProcedimentos(search: string) {
    try {
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getProcedimentosRegra(search)
      return response
    } catch (error) {
      this.context.commit('clearProcedimentos')
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getPlanosAbrangencia() {
    try {
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getPlanosAbrangencia()
      if (response.success) {
        this.context.commit('setPlanosAbrangencia', response.data)
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getValorReferenciaTipos() {
    try {
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getValorReferenciaTipos()
      if (response.success) {
        this.context.commit('setValorReferenciaTipos', response.data as KeyDisplay[] || [])
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getTipos() {
    try {
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getTipos()
      if (response.success) {
        this.context.commit('setTipos', response.data as KeyDisplay[] || [])
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getValoresReferencia() {
    try {
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getValoresReferencia()
      if (response.success) {
        this.context.commit('setValoresReferencia', response.data as KeyDisplay[] || [])
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getFiltroPorProcedimentoList(pagination: DataTablePagination) {
    try {
      const params: any = {
        regraCalculoId: this.regraDeCalculo.id,
        pagina: pagination.page || this.paginacaoRegrasDeCalculo.page,
        qtdPorPagina: pagination.rowsPerPage || this.paginacaoRegrasDeCalculo.rowsPerPage,
      }

      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getFiltroPorProcedimentoList(params)
      if (response.success) {
        this.context.commit('setFiltroPorProcedimentoList', response.data.itens)
        this.context.commit('setPaginacaoFiltroPorProcedimento', {
          descending: false,
          page: pagination.page || this.paginacaoPlanos.page,
          rowsPerPage: pagination.rowsPerPage || this.paginacaoPlanos.rowsPerPage,
          sortBy: null,
          totalItems: response.data.totalRegistros,
          rowsPerPageItems: this.paginacaoPlanos.rowsPerPageItems,
        })
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async postFiltroPorProcedimento() {
    try {
      const { id } = this.regraDeCalculo
      const params: any = {
        codigo: this.codigoFiltroProcedimento,
        descricao: this.descricaoFiltroProcedimento,
      }

      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.postFiltroPorProcedimento(params, id)
      if (response.success) {
        await this.context.dispatch('getFiltroPorProcedimentoList', this.paginacaoProcedimentos)
        this.context.commit('setCodigoFiltroProcedimento', '')
        this.context.commit('setDescricaoFiltroProcedimento', '')
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async deleteFiltroPorProcedimento(id: string) {
    try {
      const params: any = {
        filtroProcedimentoId: id,
        regraCalculoId: this.regraDeCalculo.id,
      }
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deleteFiltroPorProcedimento(params)
      if (response.success) {
        await this.context.dispatch('getFiltroPorProcedimentoList', this.paginacaoProcedimentos)
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getFuncoesProcedimento() {
    try {
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getFuncoesProcedimento()
      if (response.success) {
        this.context.commit('setFuncoesProcedimento', response.data)
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getFontesPagadoras() {
    try {
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getFontesPagadoras()
      if (response.success) {
        this.context.commit('setFontesPagadoras', response.data)
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getHospitaisGarantiaMinimaGlobal(pagination: DataTablePagination) {
    try {
      const params: any = {
        pagina: pagination.page || this.paginacaoOperadoras.page,
        qtdPorPagina: pagination.rowsPerPage || this.paginacaoOperadoras.rowsPerPage,
        id: this.regraGarantiaMinimaId,
      }
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getHospitaisGarantiaMinimaGlobal(params)
      if (response.success) {
        this.context.commit('setHospitaisGarantiaMinimaGlobal', response.data.itens)
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getGruposRepasse() {
    try {
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getGrupoRepasseAll()
      if (response.success) {
        this.context.commit('setGruposRepasse', response.data)
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getSubGruposRepasseAll() {
    try {
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getSubGruposRepasseAll()
      if (response.success) {
        this.context.commit('setSubGrupoRepasse', response.data)
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getGestores(nomeGestor?: string) {
    try {
      const params = {
        nome: nomeGestor
      }

      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getProfissionais(params)
      if (response.success) {
        this.context.commit('setGestores', response.data.pessoas)
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getLocaisExecucao() {
    try {
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getLocaisExecucaoList()
      if (response.success) {
        this.context.commit('setLocaisExecucao', response.data.itens)
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getTransacaoFinanceira() {
    try {
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getTransacaoFinanceira()
      if (response.success) {
        this.context.commit('setTransacaoFinanceira', response.data)
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getSubGruposRepasse(id: string) {
    try {
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getSubGrupoRepasse(id)
      if (response.success) {
        this.context.commit('setSubGruposRepasse', response.data)
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getPrestadoresRepasse(params?: any) {
    const mutationName = params && params.campo === 'filtroValorFixo' ? 'setPrestadoresFiltroValorFixo' : 'setPrestadoresRepasse'

    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getPessoaPrestadorAll(params || {})
      this.context.commit(mutationName, request.success ? request.data.prestadores : [])

      return request
    } catch (error) {
      this.context.commit(mutationName, [])
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getProfissionais(params?: { nome?: string, campo?: string }) {
    let mutationName = 'setProfissionaisExecutantes'

    if (params && params.campo) {
      if (params.campo === 'indicado') mutationName = 'setProfissionaisExecutantesIndicados'
      else if (params.campo === 'filtroValorFixo') mutationName = 'setProfissionaisExecutantesFiltroValorFixo'
      else if (params.campo === 'modal') mutationName = 'setProfissionaisExecutantesModal'
      else mutationName = 'setProfissionaisExecutantesAtribuidos'
    }

    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getProfissionais(params)

      this.context.commit(mutationName, request.success ? request.data.pessoas : [])
      
      return request
    } catch (error) {
      this.context.commit(mutationName, [])
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getCentroDeCusto() {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getCentroDeCusto()
      if (request.success) this.context.commit('setCentroDeCusto', request.data || [])
      return request
    } catch (error) {
      this.context.commit('clearCentroDeCusto')
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getTiposItemDesconsiderado() {
    try {
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getTiposItemDesconsiderado()
      if (response.success) {
        this.context.commit('setTiposItemDesconsiderado', response.data)
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getTransacaoFinanceiraFixo() {
    try {
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getTransacaoFinanceira()
      if (response.success) {
        this.context.commit('setTransacaoFinanceiraFixo', response.data)
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getLocalExecucaoByFontePagadora() {
    try {
      const params: any = {
        hospitalId: this.regraGestaoItem.fontePagadoraFiltroId,
      }
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getLocalExecucaoByFontePagadora(params)
      if (response.success) {
        this.context.commit('setLocalExecucaoById', response.data.itens)
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async addProcedimentos() {
    try {
      const params: any = {
        regraCalculoId: this.regraDeCalculo.id,
        valorGarantiaMinima: this.valorGarantiaMinima,
        codigoProcedimento: this.codigoProcedimento,
        descricaoProcedimento: this.descricaoProcedimento,
        criarItemGrupoRepasseDiferente: this.criarItemGrupoRepasseDiferente,
        grupoRepasseId: this.grupoRepasse,
        subGrupoRepasseId: this.subGrupoRepasse,
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.addProcedimentos(params)
      if (request.success) {
        await this.context.dispatch('getProcedimentosAll', this.paginacaoProcedimentos)
        this.context.commit('setValorGarantiaMinima', 0)
        this.context.commit('setCodigoProcedimento', '')
        this.context.commit('setDescricaoProcedimento', '')
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async addProcedimentoCompartilhado() {
    try {
      let params: any = {}

      if (this.modalProcedimentoCompartilhadoMode === 'CREATE') {
        params = {
          fontePagadoraId: this.fontePagadoraField,
          tipo: this.tipoField,
          regraCalculoId: this.regraDeCalculo.id,
          valorAplicar: this.percentualAplicar.toString(),
          funcaoProcOrigem: this.funcaoProcOrigem,
          funcaoProcDestino: this.funcaoProcDestino,
          valorReferencia: this.valorReferencia,
          grupoRepasseId: this.grupoRepasse,
          subGrupoRepasseId: this.subGrupoRepasse,
          tipoCompartilhamento: this.tipoCompartilhamento,
          codigo: this.codigoProcedimento,
        }
      } else {
        params = {
          id: this.procedimentoCompartilhadoId,
          fontePagadoraId: this.fontePagadoraField,
          tipo: this.tipoField,
          regraCalculoId: this.regraDeCalculo.id,
          valorAplicar: this.percentualAplicar.toString(),
          funcaoProcOrigem: this.funcaoProcOrigem,
          funcaoProcDestino: this.funcaoProcDestino,
          valorReferencia: this.valorReferencia,
          grupoRepasseId: this.grupoRepasse,
          subGrupoRepasseId: this.subGrupoRepasse,
          tipoCompartilhamento: this.tipoCompartilhamento,
          codigo: this.codigoProcedimento,
        }
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.addProcedimentoCompartilhado(params)

      if (request.success) {
        await this.context.dispatch('getProcedimentoCompartilhadoAll', this.paginacaoProcedimentos)
        this.context.commit('setPercentualAplicar', 0)
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async addValorFixo() {
    try {
      let params: any = {}

      if (this.modeModalRegraValoresFixos === 'CREATE') {
        params = {
          fontePagadoraId: this.regraValorFixoItem.fontePagadoraId,
          prestadorId: this.regraValorFixoItem.prestadorId,
          profissionalExecutanteId: this.regraValorFixoItem.profissionalExecutanteId,
          valor: this.regraValorFixoItem.valor,
          descricao: this.regraValorFixoItem.descricao,
          tipo: this.regraValorFixoItem.tipo,
          inicioVigencia: this.regraValorFixoItem.inicioVigencia,
          fimVigencia: this.regraValorFixoItem.fimVigencia,
          centroDeCustoId: this.regraValorFixoItem.centroDeCustoId,
          grupoRepasseId: this.regraValorFixoItem.grupoRepasseId,
          subGrupoRepasseId: this.regraValorFixoItem.subGrupoRepasseId,
          aplicaAluguel: this.regraValorFixoItem.aplicaAluguel,
          transacaoFinanceiraId: this.regraValorFixoItem.transacaoFinanceiraId,
        }
      } else {
        params = {
          id: this.regraValorFixoItem.id,
          fontePagadoraId: this.regraValorFixoItem.fontePagadoraId,
          prestadorId: this.regraValorFixoItem.prestadorId,
          profissionalExecutanteId: this.regraValorFixoItem.profissionalExecutanteId,
          valor: this.regraValorFixoItem.valor,
          descricao: this.regraValorFixoItem.descricao,
          tipo: this.regraValorFixoItem.tipo,
          inicioVigencia: this.regraValorFixoItem.inicioVigencia,
          fimVigencia: this.regraValorFixoItem.fimVigencia,
          centroDeCustoId: this.regraValorFixoItem.centroDeCustoId,
          grupoRepasseId: this.regraValorFixoItem.grupoRepasseId,
          subGrupoRepasseId: this.regraValorFixoItem.subGrupoRepasseId,
          aplicaAluguel: this.regraValorFixoItem.aplicaAluguel,
          transacaoFinanceiraId: this.regraValorFixoItem.transacaoFinanceiraId,
        }
      }

      if (params.inicioVigencia) {
        const inicioVigencia = new Date(params.inicioVigencia)
        if (!Number.isNaN(inicioVigencia.getTime())) {
          const year = inicioVigencia.getUTCFullYear()
          const month = String(inicioVigencia.getUTCMonth() + 1).padStart(2, '0')
          const day = String(inicioVigencia.getUTCDate()).padStart(2, '0')
          params.inicioVigencia = `${year}-${month}-${day}`
        }
      }

      Object.entries(params).forEach(([key, value]) => {
        if (['', null, undefined].includes(value as any)) delete params[key]
      })

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.addValorFixo(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async addRegraGestao() {
    try {
      let params: any = {
        fontePagadoraId: this.regraGestaoItem.fontePagadoraFiltroId,
        prestadorGestorId: this.regraGestaoItem.prestadorGestorId,
        gestorId: this.regraGestaoItem.gestorId,
        grupoRepasseId: this.regraGestaoItem.grupoRepasseId,
        localExecucaoId: this.regraGestaoItem.localExecucaoId,
        tipoCalculo: this.regraGestaoItem.tipoCalculo.key,
        valor: this.regraGestaoItem.valor,
        vigenciaInicio: this.regraGestaoItem.vigenciaInicio,
        vigenciaFim: this.regraGestaoItem.vigenciaFim,
        fontePagadoraFiltroId: this.regraGestaoItem.fontePagadoraFiltroId,
      }

      if (this.modeModalRegraGestao !== 'CREATE') {
        params = {
          ...params,
          id: this.regraGestaoItem.id,
        }
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.addRegraGestao(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getValorReferenciaTeto() {
    try {
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getValorReferenciaTeto()
      if (response.success) {
        this.context.commit('setValorReferenciaTeto', response.data as KeyDisplay[] || [])
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getTipoProducao() {
    try {
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getTipoProducao()
      if (response.success) {
        this.context.commit('setTipoProducao', response.data as KeyDisplay[] || [])
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async addRegraTeto() {
    try {
      let params: any = {}

      if (this.mode === 'CREATE') {
        params = {
          descricaoRegra: this.regraTetoItem.descricaoRegra,
          prestadorId: this.regraTetoItem.prestadorId,
          vigenciaInicio: this.regraTetoItem.vigenciaInicio,
          vigenciaFim: this.regraTetoItem.vigenciaFim,
          tipoProducao: this.regraTetoItem.tipoProducao,
          valorReferencia: this.regraTetoItem.valorReferencia.key,
          valorTeto: this.regraTetoItem.valorTeto,
          hospitaisId: this.regraTetoItem.hospitaisId,
        }
      } else {
        params = {
          id: this.regraTetoItem.id,
          descricaoRegra: this.regraTetoItem.descricaoRegra,
          prestadorId: this.regraTetoItem.prestadorId,
          vigenciaInicio: this.regraTetoItem.vigenciaInicio,
          vigenciaFim: this.regraTetoItem.vigenciaFim,
          tipoProducao: this.regraTetoItem.tipoProducao,
          valorReferencia: this.regraTetoItem.valorReferencia.key,
          valorTeto: this.regraTetoItem.valorTeto,
          hospitaisId: this.regraTetoItem.hospitaisId,
        }
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.addRegraTeto(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async addGarantiaMinima() {
    try {
      let params: any = {}

      if (this.modeModalGarantiaMinima === 'CREATE') {
        params = {
          valorGarantiaMinima: this.regraGarantiaMinimaItem.valorGarantiaMinima,
          prestadorId: this.regraGarantiaMinimaItem.prestadorId,
          profissionalExecutanteIdDestino: this.regraGarantiaMinimaItem.profissionalExecutanteIdDestino,
          fontePagadoraIdDestino: this.regraGarantiaMinimaItem.fontePagadoraIdDestino,
          grupoRepasseIdDestino: this.regraGarantiaMinimaItem.grupoRepasseIdDestino,
          centroDeCustoId: this.regraGarantiaMinimaItem.centroDeCustoId,
          vigenciaInicio: this.regraGarantiaMinimaItem.vigenciaInicio,
          vigenciaFim: this.regraGarantiaMinimaItem.vigencaFim,
          descricaoRegra: this.regraGarantiaMinimaItem.descricaoRegra,
          transacaoFinanceiraId: this.regraGarantiaMinimaItem.transacaoFinanceiraId,
          tiposItemDesconsiderado: this.regraGarantiaMinimaItem.tiposItemDesconsideradoEnum,
          descricaoItemRecebimentoDestino: this.regraGarantiaMinimaItem.descricaoItemRecebimentoDestino,
        }
      } else {
        params = {
          id: this.regraGarantiaMinimaId,
          valorGarantiaMinima: this.regraGarantiaMinimaItem.valorGarantiaMinima,
          prestadorId: this.regraGarantiaMinimaItem.prestadorId,
          profissionalExecutanteIdDestino: this.regraGarantiaMinimaItem.profissionalExecutanteIdDestino,
          fontePagadoraIdDestino: this.regraGarantiaMinimaItem.fontePagadoraIdDestino,
          grupoRepasseIdDestino: this.regraGarantiaMinimaItem.grupoRepasseIdDestino,
          centroDeCustoId: this.regraGarantiaMinimaItem.centroDeCustoId,
          vigenciaInicio: this.regraGarantiaMinimaItem.vigenciaInicio,
          inicioVigencia: this.regraGarantiaMinimaItem.inicioVigencia,
          vigenciaFim: this.regraGarantiaMinimaItem.vigencaFim,
          descricaoRegra: this.regraGarantiaMinimaItem.descricaoRegra,
          transacaoFinanceiraId: this.regraGarantiaMinimaItem.transacaoFinanceiraId,
          tiposItemDesconsiderado: this.regraGarantiaMinimaItem.tiposItemDesconsideradoEnum,
          descricaoItemRecebimentoDestino: this.regraGarantiaMinimaItem.descricaoItemRecebimentoDestino,
        }
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.addGarantiaMinima(params)
      if (request.success) {
        this.context.dispatch('getRegrasGarantiaMinima', this.paginacaoGarantiaMinima)
        this.context.commit('setRegraDeCalculoIdGarantiaMinima', request.data)
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async addPlano() {
    try {
      const params: any = {
        regraCalculoId: this.regraDeCalculo.id,
        abrangencia: this.selectedAbrangencia,
        fatorPlano: this.fatorPlano,
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.addPlano(params)
      if (request.success) {
        await this.context.dispatch('getPlanoAll', this.paginacaoPlanos)
        this.context.commit('setSelectedAbrangencia', '')
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async removeProcedimento(procedimentoId: string) {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.removeProcedimentoRegra(procedimentoId)
      if (request.success) await this.context.dispatch('getProcedimentosAll', this.paginacaoProcedimentos)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async removeProcedimentoCompartilhado() {
    const params: any = {
      id: this.regraDeCalculo.id,
      regraCalculoId: this.procedimentoCompartilhadoId,
    }
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.removeProcedimentoCompartilhado(params)
      if (request.success) await this.context.dispatch('getProcedimentoCompartilhadoAll', this.paginacaoProcedimentos)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async removeProcedimentoVinculado() {
    const params: any = {
      procedimentoId: this.idForDeleteProcedimentoVinculado,
      agendaGarantiaMinimaId: this.agendaGarantiaMinimaId,
    }
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.removeProcedimentoVinculado(params)
      if (request.success) await this.context.dispatch('getAllProcedimentosVinculados', this.paginacaoProcedimentos)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async removePlano(regraCalculoPlanoId: string) {
    try {
      const params: any = {
        regraCalculoId: this.regraDeCalculo.id,
        regraCalculoPlanoId,
      }
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.removePlanoRegra(params)
      if (request.success) await this.context.dispatch('getPlanoAll', this.paginacaoPlanos)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async addHospitalGarantiaMinimaGlobal() {
    try {
      const params: any = {
        regraCalculoGarantiaMinimaGlobalId: this.regraGarantiaMinimaId,
        hospitalId: this.hospitalGarantiaMinimaGlobal,
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.addHospitalGarantiaMinimaGlobal(params)
      if (request.success) {
        await this.context.dispatch('getHospitaisGarantiaMinimaGlobal', this.regraGarantiaMinimaId)
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async deleteHospitalGarantiaMinimaGlobal() {
    try {
      const params: any = {
        id: this.idForDeleteHospital,
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deleteHospitalGarantiaMinimaGlobal(params)
      if (request.success) {
        await this.context.dispatch('getHospitaisGarantiaMinimaGlobal', this.regraGarantiaMinimaId)
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  // Tabela indicação
  public paginacaoIndicacao: DataTablePagination = { ...this.paginacaoRegrasDeCalculoDefault }
  public indicacoes: any = []
  public idForDelete: number = 0
  public regraIndicacaoItem: any = {}

  @Mutation
  setIndicacoes(val: any) {
    this.indicacoes = val
  }

  @Mutation
  setDeleteId(id: number) {
    this.idForDelete = id
  }

  @Mutation
  clearRegraIndicacoes() {
    this.regraIndicacaoItem = {}
    this.profissionaisExecutantesAtribuidos = []
    this.profissionaisExecutantesIndicados = []
  }

  @Mutation
  setIndicacaoItem(item: any) {
    this.regraIndicacaoItem = item
  }

  @Mutation
  setPaginacaoIndicacao(val: DataTablePagination) {
    this.paginacaoIndicacao = val
  }

  @Action
  async getIndicacoesAll(pagination: DataTablePagination) {
    try {
      const params: any = {
        pagina: pagination.page || this.paginacaoIndicacao.page,
        qtdPorPagina: pagination.rowsPerPage || this.paginacaoIndicacao.rowsPerPage,
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getIndicacoesAll(params)
      if (request.success) {
        this.context.commit('setIndicacoes', request.data.itens)
        this.context.commit('setPaginacaoIndicacao', {
          descending: false,
          page: pagination.page || this.paginacaoIndicacao.page,
          rowsPerPage: pagination.rowsPerPage || this.paginacaoIndicacao.rowsPerPage,
          sortBy: null,
          totalItems: request.data.totalRegistros,
          rowsPerPageItems: this.paginacaoIndicacao.rowsPerPageItems,
        })
      }
      return request
    } catch (error) {
      this.context.commit('clearIndicacoes')
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async addIndicacao() {
    try {
      let params: any = {}
      if (this.modeIndicacao === 'CREATE') {
        params = {
          prestadorIndicadorId: this.regraIndicacaoItem.prestadorIndicadorId,
          profissionalExecutanteIndicadoId: this.regraIndicacaoItem.profissionalExecutanteIndicadoId,
          profissionalExecutanteIdAtribuir: this.regraIndicacaoItem.profissionalExecutanteIdAtribuir,
          qtdeLimiteMinimoInicial: this.regraIndicacaoItem.qtdeLimiteMinimoInicial,
          percentualAteLimite: this.regraIndicacaoItem.percentualAteLimite,
          percentualAcimaLimite: this.regraIndicacaoItem.percentualAcimaLimite,
          vigenciaInicio: this.regraIndicacaoItem.vigenciaInicio,
          vigenciaFim: this.regraIndicacaoItem.vigenciaFim,
          descricao: this.regraIndicacaoItem.descricao,
        }
      } else {
        params = {
          id: this.regraIndicacaoItem.id,
          prestadorIndicadorId: this.regraIndicacaoItem.prestadorIndicadorId,
          profissionalExecutanteIndicadoId: this.regraIndicacaoItem.profissionalExecutanteIndicadoId,
          profissionalExecutanteIdAtribuir: this.regraIndicacaoItem.profissionalExecutanteIdAtribuir,
          qtdeLimiteMinimoInicial: this.regraIndicacaoItem.qtdeLimiteMinimoInicial,
          percentualAteLimite: this.regraIndicacaoItem.percentualAteLimite,
          percentualAcimaLimite: this.regraIndicacaoItem.percentualAcimaLimite,
          vigenciaInicio: this.regraIndicacaoItem.vigenciaInicio,
          vigenciaFim: this.regraIndicacaoItem.vigenciaFim,
          descricao: this.regraIndicacaoItem.descricao,
        }
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.addIndicacao(params)
      if (request.success) {
        await this.context.dispatch('getIndicacoesAll', this.paginacaoIndicacao)
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async deleteIndicacao() {
    try {
      const params: any = {
        id: this.idForDelete,
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deleteIndicacao(params)
      if (request.success) {
        await this.context.dispatch('getIndicacoesAll', this.paginacaoIndicacao)
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getAllProcedimentosVinculados() {
    try {
      const params: any = {
        agendaGarantiaMinimaPeriodoId: this.agendaGarantiaMinimaId,
        pagina: this.paginacaoProcedimentos.page,
        qtdPorPagina: this.paginacaoProcedimentos.rowsPerPage,
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getAllProcedimentosVinculados(params)
      if (request.success) {
        this.context.commit('setProcedimentosVinculados', request.data.itens)
        this.context.commit('setPaginacaoProcedimentos', {
          descending: false,
          page: request.data.paginaAtual,
          rowsPerPage: request.data.qtdPorPagina,
          sortBy: null,
          totalItems: request.data.totalRegistros,
          rowsPerPageItems: request.data.qtdPorPagina,
        })
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async addProcedimentoVinculado() {
    try {
      const params: any = {
        codigoTuss: this.codigoTuss,
        agendaGarantiaMinimaPeriodoId: this.agendaGarantiaMinimaId,
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.addProcedimentoVinculado(params)
      if (request.success) {
        await this.context.dispatch('getAllProcedimentosVinculados', this.regraGarantiaMinimaId)
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  // Tabela equipes profissional
  @Mutation
  setEquipesProfissional(value: any) {
    this.equipesProfissional = value
  }

  @Mutation
  setResumoEquipeMedica(value: any) {
    this.resumoEquipeMedica = value
  }

  @Mutation
  setSelectedEquipeMedica(value: any) {
    this.selectedEquipeMedica = value
  }

  @Mutation
  setSelectedEquipeMedicaEdit(value: any) {
    this.selectedEquipeMedicaEdit = value
  }

  @Mutation
  setProfissionaisEquipeMedica(value: any) {
    this.profissionaisEquipeMedica = value
  }

  @Action
  async getEquipesProfissionalAll(pagination: DataTablePagination) {
    try {
      const params: any = {
        pagina: pagination.page || this.paginacaoEquipesProfissional.page,
        qtdPorPagina: pagination.rowsPerPage || this.paginacaoEquipesProfissional.rowsPerPage,
        regraCalculoId: this.regraDeCalculo.id || '',
      }
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getEquipesProfissionalAll(params)
      if (request.success) {
        this.context.commit('setEquipesProfissional', request.data.itens || [])
        this.context.commit('setPaginacaoEquipesProfissional', {
          descending: false,
          page: pagination.page || this.paginacaoEquipesProfissional.page,
          rowsPerPage: pagination.rowsPerPage || this.paginacaoEquipesProfissional.rowsPerPage,
          sortBy: null,
          totalItems: request.data.totalRegistros,
          rowsPerPageItems: this.paginacaoEquipesProfissional.rowsPerPageItems,
        })
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getResumoEquipeMedica() {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getResumoEquipeMedica()
      if (request.success) {
        this.context.commit('setResumoEquipeMedica', request.data.equipesMedicas || [])
      }
      return request
    } catch {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getProfissionaisEquipeMedica(pagination: DataTablePagination) {
    try {
      const params: any = {
        pagina: pagination.page || this.paginacaoIntegrantesEquipeMedica.page,
        qtdPorPagina: pagination.rowsPerPage || this.paginacaoIntegrantesEquipeMedica.rowsPerPage,
        equipeMedicaId: this.selectedEquipeMedica,
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getProfissionaisEquipeMedica(params)
      if (request.success) {
        this.context.commit('setProfissionaisEquipeMedica', request.data.itens || [])
        this.context.commit('setPaginacaoIntegrantesEquipeMedica', {
          descending: false,
          page: pagination.page || this.paginacaoIntegrantesEquipeMedica.page,
          rowsPerPage: pagination.rowsPerPage || this.paginacaoIntegrantesEquipeMedica.rowsPerPage,
          sortBy: null,
          totalItems: request.data.totalRegistros,
          rowsPerPageItems: this.paginacaoIntegrantesEquipeMedica.rowsPerPageItems,
        })
      }
      return request
    } catch {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async postVinculoEquipeMedica() {
    try {
      let params: any = {
        regraCalculoId: this.regraDeCalculo.id,
        equipeProfissionalId: this.selectedEquipeMedica,
      }

      if(this.selectedEquipeMedicaEdit){
        params.id = this.selectedEquipeMedicaEdit
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.postVinculoEquipeMedica(params)
      if (request.success) {
         await this.context.dispatch('getEquipesProfissionalAll', {
          pagina: this.paginacaoEquipesProfissional.page,
          qtdPorPagina: this.paginacaoEquipesProfissional.rowsPerPage,
        })
      }
      return request
    } catch {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async desvincularEquipeMedica(id: number) {
    try {
      const params: any = {
        equipeMedicaId: id,
      }
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deletarVinculoEquipeMedica(params.equipeMedicaId)
      if (request.success) {
        await this.context.dispatch('getEquipesProfissionalAll', {
          pagina: this.paginacaoEquipesProfissional.page,
          qtdPorPagina: this.paginacaoEquipesProfissional.rowsPerPage,
        })
      }
      return request
    } catch {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }
}
